import type { FC } from 'react';

import type { IconPropsT } from './Icon';
import Icon from './Icon';

const HighPriorityIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */

  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>High</title>
        <path
          d="M3.5 9.9c-.5.3-1.1.1-1.4-.3s-.1-1.1.4-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4-.3.5-.9.6-1.4.3L8 7.2 3.5 9.9z"
          fill="#ff5630"
        />
      </svg>
    </Icon>
  );
};

export default HighPriorityIcon;
